/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Delete_FailedInputs */

const en_carrier_notices_delete_failed = /** @type {(inputs: Carrier_Notices_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete carrier notice.`)
};

const es_carrier_notices_delete_failed = /** @type {(inputs: Carrier_Notices_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el aviso de transportista.`)
};

/**
* | output |
* | --- |
* | "Failed to delete carrier notice." |
*
* @param {Carrier_Notices_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_delete_failed = /** @type {((inputs?: Carrier_Notices_Delete_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Delete_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_delete_failed(inputs)
	return es_carrier_notices_delete_failed(inputs)
});